<div class="mcd">
  <a class="mcd__crumb" [routerLink]="backLink">
    <span class="bk-sym" aria-hidden="true">arrow_back</span>
    Message report
  </a>

  <header class="mcd__head">
    <p class="bk-eyebrow">All recipients</p>
    <h2 class="bk-heading mcd__title">{{ subject || messagesReport?.message || "Message recipients" }}</h2>
  </header>

  <app-campaign-report-details-table
    tableTitle="Recipients"
    [miniTable]="false"
    [tableOptions]="scheduleOptions"
    [selectedOption]="table.scheduleUuid"
    [tableData]="table.rows"
    [loading]="table.loading"
    [selectedSort]="arrangementSort"
    [statusFilter]="table.filter"
    [currentPage]="table.page"
    [totalPages]="table.totalPages"
    [totalItems]="table.total"
    [pageSize]="table.size"
    [filtered]="table.filtered"
    [exportable]="true"
    [exporting]="table.exporting"
    [exportNote]="table.exportNote"
    [exportFailed]="table.exportFailed"
    (search)="updateSearchTerm($event)"
    (sort)="updateSortArrangementCriteria($event)"
    (scheduleChange)="updateMessageSchedule($event)"
    (statusChange)="updateStatusFilter($event)"
    (changePage)="table.setPage($event)"
    (pageSizeChange)="table.setSize($event)"
    (export)="downloadCsv()"
  ></app-campaign-report-details-table>

  @if (table.failed) {
    <div class="mcd__retry" role="alert">
      <p class="mcd__quiet">Recipients could not be loaded. Check your connection and try again.</p>
      <button type="button" class="bk-btn bk-btn--ghost" (click)="table.load()">Try again</button>
    </div>
  }
</div>
